import React from 'react';
import PropTypes from 'prop-types';
import {Icon} from 'semantic-ui-react';

import {COVERED_WITH_DURATION_TEXT, COVERED_WITHOUT_DURATION_TEXT} from '@constants/messages';
import {Alert} from '@ui';

export const ReportsCoverageMessage = ({
    hasNoIncludesAllStreamsReport,
    hasUncoveredCombinations,
    hasEventDurationInfo,
}) => {
    if (hasNoIncludesAllStreamsReport && hasUncoveredCombinations) {
        return (
            <Alert icon={false} className='--marginBottom-10' severity='warning'>
                Some streams are not covered by a report. Please add a new report to cover all of them.
            </Alert>
        );
    }

    if (hasEventDurationInfo) {
        return (
            // TODO: The icon should be replaced with a proper MUI icon
            <Alert className='--marginBottom-10' icon={<Icon name='check circle' size='small' />} severity='info'>
                {COVERED_WITH_DURATION_TEXT}
            </Alert>
        );
    }

    return (
        <Alert className='--marginBottom-10' icon={false} severity='warning'>
            {COVERED_WITHOUT_DURATION_TEXT}
        </Alert>
    );
};

ReportsCoverageMessage.propTypes = {
    hasNoIncludesAllStreamsReport: PropTypes.bool,
    hasUncoveredCombinations: PropTypes.bool,
    hasEventDurationInfo: PropTypes.bool.isRequired,
};
